import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { WaterfallAddPrefOnDebtModal } from "features/waterfall/review/WaterfallAddPrefOnDebtModal";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import { PageMenu } from "shared/components/layout/PageMenu";

export interface WaterfallEditMenuProps {
  fundFamilyId: string;
  fundFamilyEventId: string;
  fundFamilySubEventId: string;
  fundEntityId: string;
  runWaterfall: boolean;
  isEqualizedView: boolean | undefined;
}

export const WaterfallEditMenu: React.FC<WaterfallEditMenuProps> = ({
  fundFamilyId,
  fundFamilyEventId,
  fundFamilySubEventId,
  fundEntityId,
  runWaterfall,
  isEqualizedView,
}) => {
  const { t } = useTranslation(["waterfall", "common"]);

  const {
    isOpen: isWaterfallAddPrefOnDebtModalOpen,
    onOpen: openWaterfallAddPrefOnDebtModal,
    onClose: closeWaterfallAddPrefOnDebteModal,
  } = useDisclosure();

  return (
    <Restricted permission={PermissionTypeEnum.write}>
      <PageMenu>
        <MenuItem onClick={openWaterfallAddPrefOnDebtModal}>
          {t("waterfall:review.addPrefOnDebt")}
        </MenuItem>
      </PageMenu>
      {isWaterfallAddPrefOnDebtModalOpen && (
        <WaterfallAddPrefOnDebtModal
          fundFamilyId={fundFamilyId}
          fundFamilyEventId={fundFamilyEventId}
          fundFamilySubEventId={fundFamilySubEventId}
          fundEntityId={fundEntityId}
          runWaterfall={runWaterfall}
          isEqualizedView={isEqualizedView}
          onCloseComplete={() => {
            closeWaterfallAddPrefOnDebteModal();
          }}
        />
      )}
    </Restricted>
  );
};
